<template>
   <div class="card">
      <div class="card-body m-2">
         <div class="row p-2 align-items-center">

            <!-- Add Domain Input + Button -->
            <div class="col-12 col-lg-4 mb-2 mb-lg-0 d-flex gap-2">
               <input v-model="inputDomain" type="text" class="form-control form-control-sm"
                  placeholder="&#xF002; Add Domain..."
                  style="border-radius:8px; height: 40px; font-size: 14px; font-family: 'Roboto', sans-serif, 'Font Awesome 6 Free'; font-weight: 900;"
                  v-on:keyup.enter="onEnter" />
            </div>

            <div class="col-12 col-lg-auto d-flex mb-2 mb-lg-0 gap-2">
               <button type="button" class="fw-bold btn text-light btn-sm"
                  style="font-size: 14px; height: 40px; border-radius: 8px !important; padding: 0 1.5rem; white-space: nowrap; background: #00a0c1;"
                  @click="sendData">
                  <i class="fa-solid fa-plus-circle me-1"></i> Add Domain
               </button>
            </div>
         </div>

         <!-- Table -->
         <div class="row p-2">
            <table class="table align-middle mainTable">
               <thead class="align-middle">
                  <tr>
                     <th v-for="header in headers" :key="header.value">{{ header.text }}</th>
                  </tr>
               </thead>

               <tbody v-if="domains.length <= 0">
                  <tr>
                     <td colspan="3">No domains added yet.</td>
                  </tr>
               </tbody>

               <tbody v-else>
                  <tr v-for="(domain, index) in domains" :key="index">
                     <td style="font-family: monospace; font-size: 13px;">{{ domain.domain }}</td>
                     <td>
                        <span v-if="domain.is_verified == 1" style="color: #00A36C; font-weight: 600;">
                           <i class="fa-solid fa-circle-check me-1"></i> Verified
                        </span>
                        <span v-else style="color: #EB1C24; font-weight: 600;">
                           <i class="fa-solid fa-circle-xmark me-1"></i> Unverified
                        </span>
                     </td>
                     <td>
                        <div class="d-flex gap-2">
                           <button type="button" class="ms-action-btn ms-action-btn--success"
                              
                              title="Verify Domain" @click="SetIndex(index); showVerifyModal = true;">
                              <i class="fa-solid fa-check"></i>
                           </button>
                           <button type="button" class="ms-action-btn ms-action-btn--edit"
                              
                              title="Download Verification Token" @click="downloadVerificationToken(index)">
                              <i class="fa-solid fa-circle-down"></i>
                           </button>
                           <button type="button" class="ms-action-btn ms-action-btn--delete"
                              
                              v-if="!domain.verified" @click="deleteDomain(index)">
                              <i class="fa fa-xmark"></i>
                           </button>
                        </div>
                     </td>
                  </tr>
               </tbody>
            </table>
         </div>
      </div>
   </div>

   <!-- Verify Modal -->
   <div class="modal-backdrop-custom" v-if="showVerifyModal" @click.self="showVerifyModal = false">
      <div class="modal-content-custom">
         <button @click="showVerifyModal = false" class="close-button-custom">&times;</button>
         <h5 class="modal-title-custom">
            <i class="fa-solid fa-shield-check me-2" style="color: #00a0c1;"></i>
            Verify Domain
         </h5>
         <hr>
         <div class="modal-body-custom">
            <h6 class="mb-3" style="font-weight: 600;">Verification Steps</h6>

            <div class="step-item">
               <span class="step-number">1</span>
               <span>Download the verification token</span>
            </div>
            <div class="step-item">
               <span class="step-number">2</span>
               <span>Login to domain DNS records, to create a new TXT record for the domain.</span>
            </div>
            <div class="step-item">
               <span class="step-number">3</span>
               <div>
                  <span>Create new TXT record with:</span>
                  <ul class="step-details">
                     <li>Name/Host/Alias field <strong>@</strong> or leave blank</li>
                     <li>TTL field: <strong>86400</strong> or default</li>
                     <li>Value field: paste the downloaded verification token</li>
                  </ul>
               </div>
            </div>
            <div class="step-item">
               <span class="step-number">4</span>
               <span>Click <strong>Verify</strong> below to verify the domain.</span>
            </div>
         </div>
         <div class="modal-footer-custom">
            <button type="button" class="btn btn-sm btn-modal-cancel" @click="showVerifyModal = false">Cancel</button>
            <button type="button" class="btn btn-sm text-light" style="background: #00a0c1; border-radius: 8px;"
               @click="verifyDomain(); showVerifyModal = false;">
               <i class="fa-solid fa-check me-1"></i> Verify
            </button>
         </div>
      </div>
   </div>
</template>

<script>
import { extractErrorMessage } from '@/plugins/helper.js'

export default {

   components: {},

   data() {
      return {
         showVerifyModal: false,
         headers: [
            { text: "Domain", value: "domain" },
            { text: "Verified", value: "is_verified" },
            { text: "Action", value: "action" },
         ],
         domains: [],
         inputDomain: "",
         verifyDomainIndex: 0,
      };
   },

   mounted() { this.init(); },

   methods: {
      init() { this.getDomains() },
      onEnter() { this.sendData() },
      SetIndex(index) { this.verifyDomainIndex = index },

      async getDomains() {
         await this.$axios.get("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/get-account-domains")
            .then((response) => { this.domains = response.data.account_domains })
            .catch((error) => {
               console.log(error)
               this.$toast.error(extractErrorMessage(error, "Failed to load account domains."))
            })
      },

      async verifyDomain() {
         try {
            const payload = {
               domain: this.domains[this.verifyDomainIndex].domain,
               id: this.domains[this.verifyDomainIndex].id,
               token: this.domains[this.verifyDomainIndex].token,
            }
            const resp = await this.$axios.patch("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/verify-account-domain", payload)
            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message); this.getDomains()
            }
         } catch (error) {
            this.$toast.error(extractErrorMessage(error, "Failed to verify domain."))
            console.log(error)
         }
      },

      async sendData() {
         try {
            if (this.inputDomain == "" || this.inputDomain == null || this.isValidDomain(this.inputDomain) == false) {
               this.$toast.error("Please provide a valid domain."); return
            }
            const payload = { domain: this.inputDomain }
            const resp = await this.$axios.post("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/add-account-domain", payload)
            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message); this.getDomains()
            }
            this.inputDomain = ""
         } catch (error) {
            this.inputDomain = ""
            this.$toast.error(extractErrorMessage(error, "Failed to add domain."))
            console.log(error)
         }
      },

      async deleteDomain(index) {
         try {
            const payload = { domain: this.domains[index].domain, id: this.domains[index].id }
            const resp = await this.$axios.delete("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/remove-account-domain/" + this.domains[index].id, payload)
            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message); this.getDomains()
            }
         } catch (error) {
            this.$toast.error(extractErrorMessage(error, "Failed to remove domain."))
            console.log(error)
         }
      },

      async downloadVerificationToken(index) {
         try {
            this.downloadTextFile(this.domains[index].token, this.domains[index].domain)
         } catch (error) {
            console.log(error)
            this.$toast.error("Failed to download verification token.")
         }
      },

      isValidDomain(domain) {
         const domainPattern = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
         return domainPattern.test(domain);
      },

      downloadTextFile(textData, domain) {
         const blob = new Blob([textData], { type: 'text/plain' });
         const link = document.createElement('a');
         link.href = URL.createObjectURL(blob);
         link.download = domain + '_xsurflog_verification_token.txt';
         link.click();
      }
   }
}
</script>

<style scoped>
.card { border: none; }

.btn-outline-info { color: #00A0C1; border-color: #00A0C1; }
.btn-outline-info:hover { color: #fff; background-color: #00A0C1; border-color: #00A0C1; }

/* Modal */
.modal-backdrop-custom {
   position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
   background-color: rgba(0,0,0,0.5); display: flex;
   justify-content: center; align-items: center; z-index: 1050;
}
.modal-content-custom {
   position: relative; background: #fff; padding: 2rem;
   border-radius: 14px; width: 100%; max-width: 520px;
   box-shadow: 0 8px 30px rgba(0,0,0,0.2);
}
.modal-title-custom { font-weight: 700; font-size: 1.1rem; color: #435666; margin-bottom: 0; }
.modal-content-custom hr { margin: 0.75rem 0 1rem; border-color: #e9ecef; }
.close-button-custom {
   position: absolute; top: 0.75rem; right: 1rem;
   font-size: 1.8rem; font-weight: bold; line-height: 1;
   color: #adb5bd; background: none; border: none; cursor: pointer;
}
.close-button-custom:hover { color: #435666; }
.modal-body-custom { font-size: 14px; color: #435666; }
.modal-footer-custom { margin-top: 1rem; display: flex; justify-content: flex-end; gap: 8px; }
.btn-modal-cancel { background: #e9ecef; border: none; border-radius: 8px; color: #435666; }

/* Steps */
.step-item {
   display: flex; gap: 10px; align-items: flex-start;
   margin-bottom: 12px; font-size: 13px;
}
.step-number {
   flex-shrink: 0; width: 24px; height: 24px; border-radius: 50%;
   background: #00a0c1; color: #fff; font-size: 12px; font-weight: 700;
   display: flex; align-items: center; justify-content: center;
}
.step-details {
   margin-top: 6px; padding-left: 16px; font-size: 12px; color: #6c757d;
}
</style>